import { WORKFLOW_STATUSES } from "@/lib/api";
import { cn } from "@/lib/utils";
import { Sparkles, User, ShieldCheck, CalendarClock } from "lucide-react";

export const StatusBadge = ({ status, className }) => {
  const s = WORKFLOW_STATUSES[status] || { label: status, cls: "bg-slate-100 text-slate-800 border-slate-200" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium", s.cls, className)}
    >
      {s.label}
    </span>
  );
};

const SOURCE_META = {
  ai: { label: "Drafted by AI", icon: Sparkles, cls: "text-slate-500" },
  user_edited: { label: "Edited by user", icon: ShieldCheck, cls: "text-green-700" },
  client: { label: "From client", icon: User, cls: "text-blue-700" },
};

export const SourceTag = ({ source }) => {
  const m = SOURCE_META[source] || SOURCE_META.ai;
  const Icon = m.icon;
  return (
    <span className={cn("inline-flex items-center gap-1 text-xs font-medium", m.cls)}>
      <Icon className="h-3.5 w-3.5" /> {m.label}
    </span>
  );
};

export const AiBlock = ({ children, label = "AI-generated draft — verify before use", className }) => (
  <div className={cn("border-l-4 border-slate-300 bg-slate-50 rounded-r-md px-4 py-3", className)}>
    <div className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-slate-500 mb-2">
      <Sparkles className="h-3.5 w-3.5" /> {label}
    </div>
    {children}
  </div>
);

export const LimitationWarning = ({ children }) => (
  <div data-testid="limitation-warning" className="flex gap-3 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-red-900">
    <CalendarClock className="h-5 w-5 shrink-0 mt-0.5" />
    <div className="text-sm leading-relaxed">{children}</div>
  </div>
);
